import { Box, Text, TextProps } from '@air/zephyr';
import Link from 'next/link';

export interface AgencyCardTitleProps extends Pick<TextProps, 'children'> {
  slug: string;
}

export const AgencyCardTitle = ({ children, slug }: AgencyCardTitleProps) => {
  return (
    <Text as="h2" tx={{ mb: 4, color: 'pigeon700', fontWeight: 'semibold' }} variant="text-ui-18">
      <Link href={`/agencies/${slug}`} passHref>
        <Box
          as="a"
          tx={{
            color: 'inherit',
            textDecoration: 'none',

            /**
             * This makes the entire card clickable for seeing eye users and
             * prevent screen readers from reading everything within the card
             * as a link.
             *
             * @see https://inclusive-components.design/cards/
             */
            '&:after': {
              content: '""',
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          }}
        >
          {children}
        </Box>
      </Link>
    </Text>
  );
};
